const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Я знал медную драконицу, которая любила придумывать слова. Именно ей мы обязаны таким словам, как «организовать», «подушка», «осведомлённый», «бутон» и «труд» — и это лишь малая их часть. Она бы рассмеялась, узнав, как часто люди производят эти нелепые комбинации звуков!`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
